exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-b42b2e84]{min-height:calc(50vh - var(--LINE-HEIGHT) * 4);margin-bottom:calc(var(--LINE-HEIGHT) * 4)}@media only screen and (max-width:576px){footer[data-v-b42b2e84]{min-height:calc(50 * var(--vh) - var(--LINE-HEIGHT) * 4)}}footer .logo[data-v-b42b2e84]{height:calc(var(--LINE-HEIGHT) * 2);margin-left:var(--EXTRA-SPACE-LEFT)}@media only screen and (max-width:576px){footer .logo[data-v-b42b2e84]{position:absolute;bottom:0;right:0}}footer .grid[data-v-b42b2e84]{min-height:calc(50vh - var(--LINE-HEIGHT) * 4)}@media only screen and (max-width:576px){footer .grid[data-v-b42b2e84]{min-height:calc(50vh - var(--LINE-HEIGHT) * 4)}}.smallprint[data-v-b42b2e84]{align-self:flex-end;margin-bottom:calc(var(--LINE-HEIGHT) * 2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b42b2e84","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 101
// module chunks = 0